import { UserService } from "@Services/User.service"
import { useEffect, useState } from "react"

export const useFetchUserInfos = () => {
    const [fetchingUserInfos, setFetchingUserInfos] = useState(false)
    const [userInfos, setUserInfos] = useState(null)

    const fetchUserInfos = (userId) => {
        setUserInfos(null)
        setFetchingUserInfos(true)
        //alert("fetching userinfo")
        UserService.getUserInfosById(userId ?? 0)
            .then((res) => {
                const data = res?.data?.data
                if (data?.id > 0) {
                    setUserInfos(data)
                }
                setFetchingUserInfos(false)
            })
            .catch((err) => {
                console.log({ err })
                setFetchingUserInfos(false)
            })
    }

    useEffect(() => {
        //alert("userInfos : " + `${JSON.stringify(userInfos)}`)
    }, [userInfos])

    return {
        fetchUserInfos,
        userInfos,
        fetchingUserInfos,
        setUserInfos
    }
}
